import {
  Button,
  Dialog,
  Paper,
  Grid,
  IconButton,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  LinearProgress,
  Snackbar,
  Alert,
  Slide,
  DialogTitle,
  DialogActions,
  useMediaQuery,
  tableCellClasses,
  FormControlLabel,
  Checkbox,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Chip,
  Autocomplete,
  Divider,
  Switch,
  AccordionDetails,
  AccordionSummary,
  Accordion,
  Collapse,
  InputLabel,
  Select,
  MenuItem,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  Tooltip,
  Box,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import InfoIcon from '@mui/icons-material/Info';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import PrintIcon from '@mui/icons-material/Print';
import ArticleIcon from '@mui/icons-material/Article';
import { useNavigate } from 'react-router-dom';
import ImageIcon from '@mui/icons-material/Image';
import { Container } from 'reactstrap';
import PreviewIcon from '@mui/icons-material/Preview';
import moment from 'moment';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import UIContext from '../../context/UIContext';
import axios from '../../utils/axios';
import NoResultsFound from '../../components/NoResultsFound';

const StyledTableCell = styled(TableCell)({
  color: 'white !important',
  border: 'solid 1px #dee2e6',
  fontWeight: '800',
  backgroundColor: '#47A992',
  padding: 'none',
  whiteSpace: 'nowrap',
});

const filterInitialValue = {
  FromDate: moment().startOf('month').format('YYYY-MM-DD'),
  ToDate: moment().format('YYYY-MM-DD'),
  Buyer: [{ BuyerId: 0, Buyer: 'All Buyers' }],
  Factory: [{ AccId: 0, AccName: 'All Factories' }],
  Division: { DivId: 0, Division: 'All Divisions' },
  Inspector: { UserId: 0, LoginName: 'All Inspectors' },
  DefectCategory: { CategoryId: 0, CategoryDescription: 'All Defects Category' },
  DefectSubCategory: { SubCategoryId: 0, SubCategoryDescription: 'All Defects Sub Category ' },
  InspectionType: { InspectionTypeId: 0, InspectionType: 'All Inspection Type' },
};

const DefectSummary = () => {
  const [filterData, setFilterData] = useState(filterInitialValue);
  const [prevFilterData, setPrevFilterData] = useState(filterInitialValue);
  const [Defects, setDefects] = useState([]);
  const [Inspections, setInspections] = useState([]);
  const navigate = useNavigate()
  const [filterReferenceData, setFilterReferenceData] = useState({
    Buyers: [],
    Factories: [],
    Inpsectors: [],
    Divisions: [],
    DefectCategory: [],
    DefectSubCategory: [],
    InspectionTypes: [],
  });
  const [dialogBoxData, setDialogBoxData] = useState({
    Category: '',
    SubCategory: '',
    Stage: '',
    Count: 0,
  });
  const [expanded, setExpanded] = useState(true);
  const [open, setOpen] = useState(false);

  // Defect Table
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Inspection Table
  const [InspecPage, setInspecPage] = useState(0);
  const [InspecRowsPerPage, setInspecRowsPerPage] = useState(5);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  // snackbar context
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);

  // api fetch data
  useEffect(() => {
    getAllDefect();
    GetAllHelpData();
  }, []);

  const GetAllHelpData = async () => {
    try {
      showLoading();
      const resData = await axios.get('ReferenceData/GetAllBuyers');
      const resData1 = await axios.get('ReferenceData/GetAllFactories');
      const resData2 = await axios.post('Master/User/GetAllSupervisor', { UserId: sessionStorage.getItem('UserId') });
      const resData3 = await axios.get('Master/Division/GetAllDivision');
      const resData4 = await axios.get('Master/DefectCategory/GetAllActiveDefectCategory');
      const resData5 = await axios.get('Master/DefectSubCategory/GetAllActiveDefectSubCategory');
      const resData6 = await axios.get('Master/InspectionType/GetAllInspectionType');

      setFilterReferenceData({
        Buyers: resData.data,
        Factories: resData1.data,
        Inpsectors: resData2.data,
        Divisions: resData3.data,
        DefectCategory: resData4.data,
        DefectSubCategory: resData5.data,
        InspectionTypes: resData6.data,
      });
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  };

  async function getAllDefect() {
    try {
      showLoading();
      const response = await axios.post('Report/DefectSummary/GetAllDefect', {
        FromDate: moment(filterData.FromDate).format('YYYYMMDD'),
        ToDate: moment(filterData.ToDate).format('YYYYMMDD'),
        FactoryIds: filterData.Factory.map((fac) => fac.AccId),
        BuyerIds: filterData.Buyer.map((buyer) => buyer.BuyerId),
        Inspector: filterData.Inspector.UserId,
        Division: filterData.Division.DivId,
        DefectCategory: filterData.DefectCategory.CategoryId,
        DefectSubCategory: filterData.DefectSubCategory.SubCategoryId,
        InpsectionTypeId: filterData.InspectionType.InspectionTypeId,
        UserId: sessionStorage.getItem('UserId')
      });
      setPrevFilterData(filterData);
      setDefects(response.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function getAllInspection(DefectCategory, DefectSubCategory, Critical, Major, Minor) {
    try {
      showLoading();
      const response = await axios.post('Report/DefectSummary/GetInspectionTable', {
        FromDate: moment(prevFilterData.FromDate).format('YYYYMMDD'),
        ToDate: moment(prevFilterData.ToDate).format('YYYYMMDD'),
        FactoryIds: prevFilterData.Factory.map((fac) => fac.AccId),
        BuyerIds: prevFilterData.Buyer.map((buyer) => buyer.BuyerId),
        Inspector: prevFilterData.Inspector.UserId,
        DefectCategory,
        DefectSubCategory,
        InpsectionTypeId: prevFilterData.InspectionType.InspectionTypeId,
        Critical,
        Major,
        Minor,
        UserId: sessionStorage.getItem('UserId')
      });
      setFilterData(prevFilterData);
      setInspections(response.data);
      setInspecPage(0);
      setOpen(true);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  const handleInspectionPreviewClick = (QAInspectionId) => {
    navigate(`/transactions/Inspections/preview/${QAInspectionId}`);
  };

  const handleFilterDataChange = (name, value) => {
    setFilterData({ ...filterData, [name]: value });
  };

  const handleFilterFactoryChange = (values) => {
    if (values.length === 0) {
      handleFilterDataChange('Factory', [{ AccId: 0, AccName: 'All Factories' }]);
    } else if (filterData.Factory.some((factory) => factory.AccId === 0)) {
      // If Any other is selected,"All Factorys" will get removed
      const filteredSelection = values.filter((factory) => factory.AccId !== 0);
      handleFilterDataChange('Factory', filteredSelection);
    } else if (values.some((factory) => factory.AccId === 0)) {
      // If "All Factory" is selected, remove other selections
      handleFilterDataChange('Factory', [{ AccId: 0, AccName: 'All Factories' }]);
    } else {
      handleFilterDataChange('Factory', values);
    }
  };

  const handleFilterBuyerChange = (values) => {
    if (values.length === 0) {
      handleFilterDataChange('Buyer', [{ BuyerId: 0, Buyer: 'All Buyers' }]);
    } else if (filterData.Buyer.some((buyer) => buyer.BuyerId === 0)) {
      // If Any other is selected,"All Buyers" will get removed
      const filteredSelection = values.filter((buyer) => buyer.BuyerId !== 0);
      handleFilterDataChange('Buyer', filteredSelection);
    } else if (values.some((buyer) => buyer.BuyerId === 0)) {
      // If "All Buyer" is selected, remove other selections
      handleFilterDataChange('Buyer', [{ BuyerId: 0, Buyer: 'All Buyers' }]);
    } else {
      handleFilterDataChange('Buyer', values);
    }
  };

  const handleDefectClick = (critical, major, minor, Inspection, Stage, Count) => {
    setDialogBoxData({
      Category: Inspection.CategoryDescription,
      SubCategory: Inspection.SubCategoryDescription,
      Stage,
      Count,
    });
    getAllInspection(Inspection.CategoryId, Inspection.SubCategoryId, critical, major, minor);
  };

  const handleClose = () => {
    setOpen(false);
    setInspections([]);
  };

  const filteredData = useMemo(() => {
    const newTableData = [...Defects];
    if (page > 0) setPage(0);
    return newTableData;
  }, [Defects, filterData]);
  // pagination - Defect Table
  const { emptyRows, totalRows, currentPage } = useMemo(() => {
    const totalRows = filteredData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, totalRows - page * rowsPerPage);

    return { emptyRows, totalRows, currentPage };
  }, [filteredData, page, rowsPerPage]);

  //  pagination - Inspection Table
  const { InspecEmptyRows, InspecTotalRows, InspecCurrentPage } = useMemo(() => {
    const InspecTotalRows = Inspections.length;
    const totalPages = Math.ceil(InspecTotalRows / InspecRowsPerPage);
    const InspecCurrentPage = Math.max(0, Math.min(InspecPage, totalPages - 1));
    const InspecEmptyRows =
      InspecRowsPerPage - Math.min(InspecRowsPerPage, InspecTotalRows - InspecPage * InspecRowsPerPage);

    return { InspecEmptyRows, InspecTotalRows, InspecCurrentPage };
  }, [Inspections, InspecPage, InspecRowsPerPage]);

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
        {/* table header */}
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              // borderRadius: 50,
              background: '#47A992',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              DEFECT SUMMARY
            </Typography>
          </Typography>
        </Grid>
        <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4, my: 2 }}>
          <Accordion
            expanded={expanded}
            onChange={() => {
              setExpanded((expand) => !expand);
            }}
            disableGutters
            sx={{ borderTop: 'none', borderColor: 'black', backgroundColor: 'inherit' }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon style={{ color: '#8EACCD' }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{ borderTop: 'none' }}
            >
              <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
                <IconButton aria-label="ExpandMoreIcon" color="#8EACCD">
                  <FilterAltIcon style={{ color: '#8EACCD', width: 24, height: 24 }} />
                </IconButton>
                <Typography
                  sx={{
                    color: '#8EACCD',
                    '&.active': {
                      color: 'text.primary',
                      bgcolor: 'action.selected',
                      fontWeight: 'fontWeightBold',
                    },
                  }}
                  variant="h6"
                >
                  Filters
                </Typography>
              </Stack>
            </AccordionSummary>

            <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 3 }}>
              <Grid container spacing={2} p={1} pt={0} mb={0.5} rowSpacing={2} columnSpacing={1}>
                <Grid item md={2} xs={12}>
                  {/* From Date */}
                  <TextField
                    fullWidth
                    label="From Date"
                    type="date"
                    name="fromDate"
                    value={filterData.FromDate}
                    onChange={(e) => {
                      handleFilterDataChange('FromDate', e.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    size="small"
                    inputProps={{ max: '9999-12-31' }}
                  />
                </Grid>
                <Grid item md={2} xs={12}>
                  {/* To Date */}
                  <TextField
                    fullWidth
                    label="To Date"
                    type="date"
                    name="ToDate"
                    value={filterData.ToDate}
                    onChange={(e) => {
                      handleFilterDataChange('ToDate', e.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    size="small"
                    inputProps={{ max: '9999-12-31' }}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <Autocomplete
                    multiple
                    options={[{ AccId: 0, AccName: 'All Factories' }, ...filterReferenceData.Factories]}
                    getOptionLabel={(factory) => factory.AccName}
                    isOptionEqualToValue={(option, value) => option.AccId === value.AccId}
                    renderOption={(props, factory) => (
                      <li {...props} key={factory.AccId}>
                        {factory.AccName}
                      </li>
                    )}
                    value={filterData.Factory || null}
                    name="Factory"
                    onChange={(event, values) => {
                      handleFilterFactoryChange(values);
                    }}
                    size="small"
                    disableClearable
                    renderInput={(params) => <TextField {...params} label="Factory" />}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <Autocomplete
                    multiple
                    options={[{ BuyerId: 0, Buyer: 'All Buyers' }, ...filterReferenceData.Buyers]}
                    getOptionLabel={(buyers) => buyers.Buyer}
                    isOptionEqualToValue={(option, value) => option.BuyerId === value.BuyerId}
                    renderOption={(props, buyers) => (
                      <li {...props} key={buyers.BuyerId}>
                        {buyers.Buyer}
                      </li>
                    )}
                    value={filterData.Buyer}
                    name="Buyer"
                    onChange={(event, values) => {
                      handleFilterBuyerChange(values);
                    }}
                    size="small"
                    disableClearable
                    renderInput={(params) => <TextField {...params} label="Buyer" />}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <Autocomplete
                    options={[{ UserId: 0, LoginName: 'All Inspector' }, ...filterReferenceData.Inpsectors]}
                    getOptionLabel={(inspector) => inspector.LoginName}
                    isOptionEqualToValue={(value) => value.UserId === filterData.Inspector.UserId}
                    renderOption={(props, user) => (
                      <li {...props} key={user.UserId}>
                        {user.LoginName} {user.Designation ? ` ( ${user.Designation} ) ` : ''}
                      </li>
                    )}
                    value={filterData.Inspector || null}
                    name="Inspector"
                    onChange={(event, value) => {
                      handleFilterDataChange('Inspector', value);
                    }}
                    size="small"
                    disableClearable
                    renderInput={(params) => <TextField {...params} label="Inspector" />}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <Autocomplete
                    options={[{ DivId: 0, Division: 'All Division' }, ...filterReferenceData.Divisions]}
                    getOptionLabel={(Division) => Division.Division}
                    isOptionEqualToValue={(div) => div.DivId === filterData.Division.DivId}
                    renderOption={(props, division) => (
                      <li {...props} key={division.DivId}>
                        {division.Division}
                      </li>
                    )}
                    value={filterData.Division || null}
                    name="Division"
                    onChange={(event, value) => {
                      handleFilterDataChange('Division', value);
                    }}
                    size="small"
                    disableClearable
                    renderInput={(params) => <TextField {...params} label="Division" />}
                  />
                </Grid>

                <Grid item md={4} xs={12}>
                  <Autocomplete
                    options={[
                      { CategoryId: 0, CategoryDescription: 'All Defects Category' },
                      ...filterReferenceData.DefectCategory,
                    ]}
                    getOptionLabel={(Defect) => Defect.CategoryDescription}
                    isOptionEqualToValue={(div) => div.CategoryId === filterData.DefectCategory.CategoryId}
                    renderOption={(props, Defect) => (
                      <li {...props} key={Defect.CategoryId}>
                        {Defect.CategoryDescription}
                      </li>
                    )}
                    value={filterData.DefectCategory || null}
                    name="DefectCategory"
                    onChange={(event, value) => {
                      handleFilterDataChange('DefectCategory', value);
                    }}
                    size="small"
                    disableClearable
                    renderInput={(params) => <TextField {...params} label="Defect Category" />}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <Autocomplete
                    options={[
                      { SubCategoryId: 0, SubCategoryDescription: 'All Defects Sub Category ' },
                      ...filterReferenceData.DefectSubCategory,
                    ]}
                    getOptionLabel={(defect) => defect.SubCategoryDescription}
                    isOptionEqualToValue={(div) => div.SubCategoryId === filterData.DefectSubCategory.SubCategoryId}
                    renderOption={(props, defect) => (
                      <li {...props} key={defect.SubCategoryId}>
                        {defect.SubCategoryDescription}
                      </li>
                    )}
                    value={filterData.DefectSubCategory || null}
                    name="DefectSubCategory"
                    onChange={(event, value) => {
                      handleFilterDataChange('DefectSubCategory', value);
                    }}
                    size="small"
                    disableClearable
                    renderInput={(params) => <TextField {...params} label="Defect Sub Category" />}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <Autocomplete
                    options={[
                      { InspectionTypeId: 0, InspectionType: 'All Inspection Type' },
                      ...filterReferenceData.InspectionTypes,
                    ]}
                    getOptionLabel={(inspectionType) => inspectionType.InspectionType}
                    isOptionEqualToValue={(div) => div.InspectionTypeId === filterData.InspectionType.InspectionTypeId}
                    renderOption={(props, inspectionType) => (
                      <li {...props} key={inspectionType.InspectionTypeId}>
                        {inspectionType.InspectionType}
                      </li>
                    )}
                    value={filterData.InspectionType || null}
                    name="InspectionType"
                    onChange={(event, value) => {
                      handleFilterDataChange('InspectionType', value);
                    }}
                    size="small"
                    disableClearable
                    renderInput={(params) => <TextField {...params} label="Inpsection Type" />}
                  />
                </Grid>

                <Grid item xs={1} sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => {
                      getAllDefect();
                    }}
                    sx={{ boxShadow: 0 }}
                  >
                    View
                  </Button>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Stack>
        <Collapse in={filteredData.length > 0}>
          <TableContainer sx={{ borderRadius: '7px', maxHeight: '450px' }} component={Paper} elevation={2}>
            <Table className="table-bordered" size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center">S.No</StyledTableCell>
                  <StyledTableCell align="left">Defect Category</StyledTableCell>
                  <StyledTableCell align="left">Defect Sub Category</StyledTableCell>
                  <StyledTableCell align="left">Critical</StyledTableCell>
                  <StyledTableCell align="left">Major</StyledTableCell>
                  <StyledTableCell align="left">Minor</StyledTableCell>

                  {/* <StyledTableCell align="left">Inspection Detail</StyledTableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {(rowsPerPage > 0
                  ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  : filteredData
                ).map((Inspection, i) => (
                  <TableRow key={Inspection.SNo} hover>
                    <TableCell align="center">{Inspection.SNo}</TableCell>
                    <TableCell align="left">{Inspection.CategoryDescription}</TableCell>
                    <TableCell align="left">{Inspection.SubCategoryDescription}</TableCell>

                    <TableCell align="center">
                      <Tooltip title="Show Inspections">
                        <Chip
                          label={Inspection.Critical}
                          size="small"
                          onClick={() => {
                            handleDefectClick(
                              Inspection.Critical > 0 ? 1 : 0,
                              null,
                              null,
                              Inspection,
                              'Critical',
                              Inspection.Critical
                            );
                          }}
                          color="error"
                          icon={<InfoIcon style={{ color: '#D32F2F' }} />}
                          variant="outlined"
                          sx={{ borderColor: '#D32F2F', backgroundColor: '#FFEBEE', color: '#D32F2F' }}
                        />
                      </Tooltip>
                    </TableCell>

                    <TableCell align="center">
                      <Tooltip title="Show Inspections">
                        <Chip
                          label={Inspection.Major}
                          size="small"
                          onClick={() => {
                            handleDefectClick(
                              null,
                              Inspection.Major > 0 ? 1 : 0,
                              null,
                              Inspection,
                              'Major',
                              Inspection.Major
                            );
                          }}
                          color="warning"
                          icon={<InfoIcon style={{ color: '#FFA000' }} />}
                          variant="outlined"
                          sx={{ borderColor: '#FFA000', backgroundColor: '#FFF3E0', color: '#FFA000' }}
                        />
                      </Tooltip>
                    </TableCell>

                    <TableCell align="center">
                      <Tooltip title="Show Inspections">
                        <Chip
                          label={Inspection.Minor}
                          size="small"
                          onClick={() => {
                            handleDefectClick(
                              null,
                              null,
                              Inspection.Minor > 0 ? 1 : 0,
                              Inspection,
                              'Minor',
                              Inspection.Minor
                            );
                          }}
                          color="success"
                          icon={<InfoIcon style={{ color: '#388E3C' }} />}
                          variant="outlined"
                          sx={{ borderColor: '#388E3C', backgroundColor: '#E8F5E9', color: '#388E3C' }}
                        />
                      </Tooltip>
                    </TableCell>

                    {/* <TableCell align="center">
                      <IconButton aria-label="inspections-detail" onClick={null} title=" Inspection Report">
                        <ArticleIcon color="primary" />
                      </IconButton>
                    </TableCell> */}
                  </TableRow>
                ))}
                {/* {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={11} />
                </TableRow>
              )} */}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={totalRows}
            rowsPerPage={rowsPerPage}
            page={currentPage} // Use the calculated currentPage value
            onPageChange={(event, newPage) => setPage(newPage)}
            onRowsPerPageChange={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(0); // Reset the page when rowsPerPage changes
            }}
            mt={2}
          />
        </Collapse>
        {!filteredData.length > 0 && <NoResultsFound />}
      </Container>
      <Dialog open={open} onClose={handleClose} fullScreen={fullScreen} fullWidth maxWidth="lg">
        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} p={1} pb={0}>
          <Grid container alignItems="center" spacing={2}>
            {/* Defect Details */}
            <Stack width={"100%"} direction={'row'} alignItems="center" justifyContent="center" p={2} pb={0} gap={3}>
              <Card sx={{ px: 3, py: 1 }}>
                <Typography variant="h6" fontWeight={600} color="primary">
                  Defect Category
                </Typography>
                <Typography variant="body1" fontWeight={500}>
                  {dialogBoxData.Category}
                </Typography>
              </Card>
              <Card sx={{ px: 3, py: 1 }}>
                <Typography variant="h6" fontWeight={600} color="primary">
                  Defect Sub Category
                </Typography>
                <Typography variant="body1" fontWeight={500}>
                  {dialogBoxData.SubCategory}
                </Typography>
              </Card>
              <Chip
                sx={{
                  borderColor:
                    dialogBoxData.Stage === 'Critical'
                      ? '#D32F2F'
                      : dialogBoxData.Stage === 'Major'
                        ? '#FFA000'
                        : '#388E3C',
                  backgroundColor:
                    dialogBoxData.Stage === 'Critical'
                      ? '#FFEBEE'
                      : dialogBoxData.Stage === 'Major'
                        ? '#FFF3E0'
                        : '#E8F5E9',
                  color:
                    dialogBoxData.Stage === 'Critical'
                      ? '#D32F2F'
                      : dialogBoxData.Stage === 'Major'
                        ? '#FFA000'
                        : '#388E3C',
                  fontSize: '1rem',
                  fontWeight: 'bold',
                  px: 2,
                  py: 1,
                }}
                label={`${dialogBoxData.Stage} : ${dialogBoxData.Count}`}
                size="medium"
                variant="outlined"
              />
            </Stack>




          </Grid>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
        <Stack sx={{ p: 2 }}>
          <TableContainer sx={{ borderRadius: '7px', maxHeight: '450px' }} component={Paper} elevation={2}>
            <Table className="table-bordered" size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center">S.No</StyledTableCell>
                  <StyledTableCell align="left">Inspection No</StyledTableCell>
                  <StyledTableCell align="left">Inspection Date</StyledTableCell>
                  <StyledTableCell align="left">Buyer</StyledTableCell>
                  <StyledTableCell align="left">Factory</StyledTableCell>
                  <StyledTableCell align="left">IPO / Style</StyledTableCell>
                  <StyledTableCell align="center">Inspection Type</StyledTableCell>
                  <StyledTableCell align="center">Result</StyledTableCell>
                  <StyledTableCell align="center">Inspector</StyledTableCell>
                  <StyledTableCell align="center">Assisting QA</StyledTableCell>
                  <StyledTableCell align="center">Production Coordinator</StyledTableCell>
                  <StyledTableCell align="center">View</StyledTableCell>
                  {/* <StyledTableCell align="center">Actions</StyledTableCell> */}
                </TableRow>
              </TableHead>

              <TableBody>
                {(InspecRowsPerPage > 0
                  ? Inspections.slice(
                    InspecPage * InspecRowsPerPage,
                    InspecPage * InspecRowsPerPage + InspecRowsPerPage
                  )
                  : Inspections
                ).map((inspection, i) => (
                  <TableRow key={inspection.QAInspectionId} hover>
                    <TableCell align="center">{inspection.SNo}</TableCell>
                    <TableCell align="center">{inspection.InspectionCode}</TableCell>
                    <TableCell align="left">{inspection.QAINSPECTIONDATE}</TableCell>
                    <TableCell align="left">{inspection.Buyer}</TableCell>
                    <TableCell align="left">{inspection.Factory}</TableCell>
                    <TableCell align="left">{inspection.StyleNo}</TableCell>
                    <TableCell align="left">{inspection.InspectionType}</TableCell>
                    <TableCell align="left">
                      <Chip
                        color={
                          inspection.Status?.trim() === 'P'
                            ? 'success'
                            : inspection.Status?.trim() === 'F'
                              ? 'error'
                              : 'warning'
                        }
                        label={
                          inspection.Status?.trim() === 'P'
                            ? 'Pass'
                            : inspection.Status?.trim() === 'F'
                              ? 'Fail'
                              : 'Hold'
                        }
                        size="small"
                        variant="outlined"
                      />
                    </TableCell>
                    <TableCell align="left">{inspection.Auditor}</TableCell>
                    <TableCell align="left">{inspection.AssistQAs}</TableCell>
                    <TableCell align="left">{inspection.Coordinators}</TableCell>
                    <TableCell align="center">
                      <IconButton
                        aria-label="print-inspection-report"
                        onClick={() => {
                          handleInspectionPreviewClick(inspection.QAInspectionId);
                        }}
                        title="View Inspection"
                      >
                        <PreviewIcon color="primary" />
                      </IconButton>
                    </TableCell>

                    {/* <TableCell align="center" sx={{ padding: '0' }}>
                    <IconButton
                      aria-label="Edit"
                      onClick={() => {
                        setEdit(true);
                        setOpen(true);
                        handleEditClick(FactoryOrderSheet);
                      }}
                    >
                      <EditIcon color="primary" />
                    </IconButton>
                    <IconButton
                      aria-label="Delete"
                      onClick={() => {
                        setDeleteId(FactoryOrderSheet.FactoryOrderSheetId);
                        setOpenDelete(true);
                      }}
                    >
                      <DeleteForeverIcon color="error" />
                    </IconButton>
                  </TableCell> */}
                  </TableRow>
                ))}
                {/* {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={11} />
                </TableRow>
              )} */}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={InspecTotalRows}
            rowsPerPage={InspecRowsPerPage}
            page={InspecCurrentPage} // Use the calculated currentPage value
            onPageChange={(event, newPage) => setInspecPage(newPage)}
            onRowsPerPageChange={(event) => {
              setInspecRowsPerPage(parseInt(event.target.value, 10));
              setInspecPage(0); // Reset the page when rowsPerPage changes
            }}
            mt={2}
          />
        </Stack>
        {/* <DialogActions sx={{ p: 1, display: 'flex', justifyContent: 'center' }}>
          <Button onClick={handleClose} variant="contained" color="warning">
            Close
          </Button>
        </DialogActions> */}
      </Dialog>
    </>
  );
};

export default DefectSummary;
